<template>
    <div>
        <button-secondary @click="open">
            <template slot="icon"><i class="fa fa-book mr-2"></i></template>
            Alle Buchungen anzeigen
            <i v-show="room.pending_bookings_count > 0" class="fa fa-fw fa-bell-o mr-2 text-yellow-500"></i>
        </button-secondary>

        <portal to="modal" v-if="showModal">
            <modal @close="showModal = false">
                <template v-slot:header>Buchungen {{ room.name }}</template>

                <loading v-show="loading"></loading>

                <div v-show="!loading">
                    <div class="mb-8" v-show="room.requires_confirmation">
                        <h2>Anfragen</h2>

                        <p v-show="pendingBookings.length === 0">Keine aktuellen Anfragen.</p>

                        <tailwind-table :header="['User', 'Zeitraum', 'Status', 'Anmerkungen', 'Serienbuchung','']" v-show="pendingBookings.length > 0">
                            <tr v-for="(booking, i) in pendingBookings" :class="{'bg-gray-50': i % 2}">
                                <td class="px-6 py-3">
                                    <span v-if="booking.user">
                                        {{ booking.user.first_name }} {{ booking.user.name }}
                                    </span>
                                </td>
                                <td class="px-6 py-3">
                                    {{ booking.start | dayOfWeek }} - {{ booking.start | date }} {{ booking.start | time }} - {{ booking.end | time }} Uhr
                                </td>
                                <td class="px-6 py-3"
                                    :class="{
                                        'text-green-500': booking.status === 'confirmed',
                                        'text-red-500': booking.status === 'denied',
                                        'text-yellow-500': booking.status === 'pending'
                                    }">
                                    {{ booking.status | status }}
                                </td>
                                <td class="px-6 py-3">
                                    {{ booking.comment }}
                                    <span v-show="booking.event?.title" class="text-gray-500">
                                        <br><span class="text-sm font-medium text-gray-500">Veranstaltungstitel</span><br>
                                        <span
                                            class="mr-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-200 text-gray-800">
                                            {{ booking.event?.title }}
                                        </span>
                                    </span>
                                    <span v-if="booking.room_layout" class="text-gray-500">
                                        <br><span class="text-sm font-medium text-gray-500">Raumlayout</span><br>
                                        <span
                                            class="mr-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-200 text-gray-800">
                                            {{ booking.room_layout.name }}
                                        </span>
                                    </span>
                                    <span v-if="booking.caterings.length" class="text-gray-500">
                                        <br><span class="text-sm font-medium text-gray-500">Catering</span><br>
                                       <span v-for="catering in booking.caterings"
                                             class="mr-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-200 text-gray-800">
                                                      {{ catering.name }}
                                       </span>
                                    </span>
                                    <span v-show="booking.postable_equipment.length > 0" class="text-gray-500">
                                        <br><span class="text-sm font-medium text-gray-500">Zubuchbares Equipment</span><br>
                                        <span v-for="equipment in booking.postable_equipment"
                                              class="mr-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-200 text-gray-800">
                                            {{ equipment.name }}
                                        </span>
                                    </span>
                                    <span v-show="booking.event?.person" class="text-gray-500">
                                        <br><span class="text-sm font-medium text-gray-500">Teilnehmeranzahl</span><br>
                                        <span
                                            class="mr-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-200 text-gray-800">
                                            {{ booking.event?.person }}
                                        </span>
                                    </span>
                                    <span v-show="booking.event?.phone" class="text-gray-500">
                                        <br><span class="text-sm font-medium text-gray-500">Rufnummer für Rückfragen</span><br>
                                        <span
                                            class="mr-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-200 text-gray-800">
                                            {{ booking.event?.phone }}
                                        </span>
                                    </span>
                                </td>
                                <td class="px-6 py-3"><span
                                    v-if="booking.conference_room_booking_series"> {{
                                        booking.conference_room_booking_series.begin | date
                                    }} - {{
                                        booking.conference_room_booking_series.end | date
                                    }} Frequenz: {{
                                        booking.conference_room_booking_series.cycle
                                    }} {{ getReadableInterval(booking.conference_room_booking_series.type) }}</span>
                                </td>
                                <td class="px-6 py-3 grid-cols-2 gap-4">
                                    <confirm-dialog>
                                        <button-secondary>
                                            <i class="fa fa-check text-green-500 mr-2"></i> Bestätigen
                                        </button-secondary>
                                        <template v-slot:header>Buchung Bestätigen</template>
                                        <template v-slot:question>
                                           <span v-show="!booking.conference_room_booking_series_id"> Soll die Buchung für
                                            <span class="font-bold">{{ booking.start | date }}</span>
                                            wirklich bestätigt werden?</span>
                                            <span v-show="booking.conference_room_booking_series_id"> Die ausgewählte Buchung für den <span
                                                class="font-bold">{{ booking.start | date }}</span> ist Teil einer Serienbuchung. Möchten Sie nur die Buchung für den <span
                                                class="font-bold">{{ booking.start | date }}</span> bestätigen, oder die gesamte Serie?</span>
                                        </template>
                                        <template v-slot:confirm>
                                            <div class="inline-flex">
                                                <button-secondary class="mr-1" @click="confirm(booking.id,false)">
                                                    <i class="fa fa-check text-green-500"></i> Buchung Bestätigen
                                                </button-secondary>
                                                <button-secondary v-show="booking.conference_room_booking_series_id" @click="confirm(booking.id,true)">
                                                    <i class="fa fa-check text-green-500"></i> Serie Bestätigen
                                                </button-secondary>
                                            </div>
                                        </template>
                                    </confirm-dialog>
                                    <confirm-dialog>
                                        <button-secondary>
                                            <i class="fa fa-times text-red-500 mr-2"></i> Ablehnen
                                        </button-secondary>
                                        <template v-slot:header>Buchung Bestätigen</template>
                                        <template v-slot:question>
                                           <span v-show="!booking.conference_room_booking_series_id"> Soll die Buchung für
                                            <span class="font-bold">{{ booking.start | date }}</span>
                                            wirklich abgelehnt werden?</span>
                                            <span v-show="booking.conference_room_booking_series_id"> Die ausgewählte Buchung für den <span
                                                class="font-bold">{{ booking.start | date }}</span> ist Teil einer Serienbuchung. Möchten Sie nur die Buchung für den <span
                                                class="font-bold">{{ booking.start | date }}</span> ablehnen, oder die gesamte Serie?</span>
                                        </template>
                                        <template v-slot:confirm>
                                            <div class="inline-flex">
                                                <button-secondary class="mr-1" @click="decline(booking.id,false)">
                                                    <i class="fa fa-times text-red-500 mr-2"></i> Buchung Ablehnen
                                                </button-secondary>
                                                <button-secondary v-show="booking.conference_room_booking_series_id" @click="decline(booking.id,true)">
                                                    <i class="fa fa-times text-red-500 mr-2"></i> Serie Ablehnen
                                                </button-secondary>
                                            </div>
                                        </template>
                                    </confirm-dialog>
                                </td>
                            </tr>
                        </tailwind-table>
                    </div>

                    <div class="mb-8">
                        <h2>Buchungen</h2>

                        <p v-show="confirmedBookings.length === 0">Keine aktuellen Buchungen.</p>

                        <tailwind-table class="mb-4" :header="['Datum', 'Bucher', 'Anmerkungen', 'Serienbuchung', '']"
                                        v-show="confirmedBookings.length > 0">
                            <tr v-for="(booking, i) in confirmedBookings" :class="{'bg-gray-50': i % 2}">
                                <td class="px-6 py-3">{{ booking.start | dayOfWeek }} - {{ booking.start | date }} {{ booking.start | time }} -
                                    {{ booking.end | time }} Uhr
                                </td>
                                <td class="px-6 py-3">
                                    {{ booking.user ? booking.user.name : '-' }}
                                </td>
                                <td class="px-6 py-3">
                                    {{ booking.comment }}
                                    <span v-show="booking.event?.title" class="text-gray-500">
                                        <br><span class="text-sm font-medium text-gray-500">Veranstaltungstitel</span><br>
                                        <span
                                            class="mr-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-200 text-gray-800">
                                            {{ booking.event?.title }}
                                        </span>
                                    </span>
                                    <span v-if="booking.room_layout" class="text-gray-500">
                                        <br><span class="text-sm font-medium text-gray-500">Raumlayout</span><br>
                                        <span
                                            class="mr-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-200 text-gray-800">
                                            {{ booking.room_layout.name }}
                                        </span>
                                    </span>
                                    <span v-if="booking.caterings.length" class="text-gray-500">
                                        <br><span class="text-sm font-medium text-gray-500">Catering</span><br>
                                       <span v-for="catering in booking.caterings"
                                             class="mr-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-200 text-gray-800">
                                                      {{ catering.name }}
                                       </span>
                                    </span>
                                    <span v-show="booking.postable_equipment.length > 0" class="text-gray-500">
                                        <br><span class="text-sm font-medium text-gray-500">Zubuchbares Equipment</span><br>
                                        <span v-for="equipment in booking.postable_equipment"
                                              class="mr-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-200 text-gray-800">
                                            {{ equipment.name }}
                                        </span>
                                    </span>
                                    <span v-show="booking.event?.person" class="text-gray-500">
                                        <br><span class="text-sm font-medium text-gray-500">Teilnehmeranzahl</span><br>
                                        <span
                                            class="mr-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-200 text-gray-800">
                                            {{ booking.event?.person }}
                                        </span>
                                    </span>
                                    <span v-show="booking.event?.phone" class="text-gray-500">
                                        <br><span class="text-sm font-medium text-gray-500">Rufnummer für Rückfragen</span><br>
                                        <span
                                            class="mr-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-200 text-gray-800">
                                            {{ booking.event?.phone }}
                                        </span>
                                    </span>
                                </td>
                                <td class="px-6 py-3"><span
                                    v-if="booking.conference_room_booking_series"> {{
                                        booking.conference_room_booking_series.begin | date
                                    }} - {{
                                        booking.conference_room_booking_series.end | date
                                    }} Frequenz: {{
                                        booking.conference_room_booking_series.cycle
                                    }} {{ getReadableInterval(booking.conference_room_booking_series.type) }}</span>
                                </td>
                                <td class="px-6 py-3 text-right flex" v-if="can.update.conference_room_booking">

                                    <conference-room-booking-edit @changed="load" :booking="booking"></conference-room-booking-edit>
                                    <conference-room-booking-delete @deleted="removed" :booking="booking" ></conference-room-booking-delete>

                                </td>
                            </tr>
                        </tailwind-table>
                    </div>

                    <div class="mb-8" v-show="deniedBookings.length > 0">
                        <h2>Abgelehnte Buchungen</h2>

                        <tailwind-table class="mb-4" :header="['Datum', 'Bucher', 'Anmerkungen']"
                                        v-show="bookings.length > 0">
                            <tr v-for="(booking, i) in deniedBookings" :class="{'bg-gray-50': i % 2}">
                                <td class="px-6 py-3">{{ booking.start | dayOfWeek }} - {{ booking.start | date }} {{ booking.start | time }} -
                                    {{ booking.end | time }} Uhr
                                </td>
                                <td class="px-6 py-3">
                                    {{ booking.user ? booking.user.name : '-' }}
                                </td>
                                <td class="px-6 py-3">
                                    {{ booking.comment }}
                                    <span v-show="booking.event?.title" class="text-gray-500">
                                        <br><span class="text-sm font-medium text-gray-500">Veranstaltungstitel</span><br>
                                        <span
                                            class="mr-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-200 text-gray-800">
                                            {{ booking.event?.title }}
                                        </span>
                                    </span>
                                    <span v-if="booking.room_layout" class="text-gray-500">
                                        <br><span class="text-sm font-medium text-gray-500">Raumlayout</span><br>
                                        <span
                                            class="mr-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-200 text-gray-800">
                                            {{ booking.room_layout.name }}
                                        </span>
                                    </span>
                                    <span v-if="booking.catering" class="text-gray-500">
                                        <br><span class="text-sm font-medium text-gray-500">Catering</span><br>
                                        <span
                                            class="mr-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-200 text-gray-800">
                                            {{ booking.catering.name }}
                                        </span>
                                    </span>
                                    <span v-show="booking.postable_equipment.length > 0" class="text-gray-500">
                                        <br><span class="text-sm font-medium text-gray-500">Zubuchbares Equipment</span><br>
                                        <span v-for="equipment in booking.postable_equipment"
                                              class="mr-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-200 text-gray-800">
                                            {{ equipment.name }}
                                        </span>
                                    </span>
                                    <span v-show="booking.event?.person" class="text-gray-500">
                                        <br><span class="text-sm font-medium text-gray-500">Teilnehmeranzahl</span><br>
                                        <span
                                            class="mr-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-200 text-gray-800">
                                            {{ booking.event?.person }}
                                        </span>
                                    </span>
                                    <span v-show="booking.event?.phone" class="text-gray-500">
                                        <br><span class="text-sm font-medium text-gray-500">Rufnummer für Rückfragen</span><br>
                                        <span
                                            class="mr-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-200 text-gray-800">
                                            {{ booking.event?.phone }}
                                        </span>
                                    </span>
                                </td>
                                <!-- disabling confirmation after booking is denied, because this conference room could be booked by another user/booking in meanwhile -->
                                <!-- <td class="px-6 py-3 text-right">
                                   <button-secondary @click="confirm(booking.id)">
                                     <i class="fa fa-check text-green-500 mr-2"></i> Bestätigen
                                   </button-secondary>

                                 </td>-->
                            </tr>
                        </tailwind-table>
                    </div>
                </div>
            </modal>
        </portal>
    </div>
</template>

<script>
import Modal from "./Modal";
import ButtonSecondary from "./UI/ButtonSecondary";
import ButtonPrimary from "./UI/ButtonPrimary";
import TailwindTable from "./UI/TailwindTable";
import Loading from "./UI/Loading";
import ConfirmDialog from "./UI/ConfirmDialog";
import ButtonDelete from "./UI/ButtonDelete";
import sortBy from "lodash/sortBy";
import ConferenceRoomBookingEdit from "./ConferenceRoomBookingEdit.vue";
import ConferenceRoomBookingDelete from "./ConferenceRoomBookingDelete.vue";

export default {
    name: "ConferenceRoomBooking",

    components: {
        ConferenceRoomBookingDelete,
        ConferenceRoomBookingEdit,
        ButtonDelete,
        ConfirmDialog,
        Loading,
        TailwindTable,
        ButtonPrimary,
        ButtonSecondary,
        Modal,
    },

    inject: ['can'],

    props: ['room'],

    data: () => ({
        showModal: false,
        loading: false,
        bookings: [],
        roomToSwap: null,
        bookingToSwap: null,
    }),

    computed: {
        pendingBookings() {
            return this.bookings.filter(b => b.status === 'pending');
        },
        deniedBookings() {
            return this.bookings.filter(b => b.status === 'denied');
        },
        confirmedBookings() {
            return this.bookings.filter(b => b.status === 'confirmed');
        },
    },

    filters: {
        time(val) {
            return val.substring(11, 16);
        },
        date(val) {
            let [y, m, d] = val.substring(0, 10).split('-');
            return `${d}.${m}.${y}`;
        },
        dayOfWeek(val) {
            let [y, m, d] = val.substring(0, 10).split('-');
            return new Date(`${y}-${m}-${d}`).toLocaleString('de-de', {  weekday: 'short' });
        },
        status(val) {
            switch (val){
                case 'confirmed' : return 'bestätigt'
                case 'denied' : return 'abgelehnt'
                case 'pending' : return 'ausstehend'
            }
        }
    },

    methods: {
        open() {
            this.showModal = true;
            this.load();
        },
        load() {
            this.loading = true;
            this.$http.get(`/admin/conference_rooms/${this.room.id}`)
                .then(response => {
                    this.loading = false;
                    this.bookings = sortBy(response.data.bookings, 'start')
                        .filter(b => (new Date(b.end)).setHours(0,0,0,0) >= (new Date()).setHours(0,0,0,0));
                })
                .catch(error => {
                    this.loading = false;
                    this.$root.$emit('error', error);
                });
        },
        removed() {
            this.load();
            this.$root.$emit('alert', 'Buchung gelöscht.');
            this.$emit('reload');
        },
        confirm(id, series = false) {
            this.updateStatus(id, 'confirmed',series);
        },
        decline(id, series = false) {
            this.updateStatus(id, 'denied',series);
        },
        updateStatus(id, status, series) {
            this.loading = true;
            this.$http
                .put(`/admin/conference_room_bookings/${id}`, {
                    status: status,
                    series
                })
                .then(() => {
                    if (status === 'confirmed') {
                        this.$root.$emit('alert', 'Buchung wurde bestätigt.');
                    }
                    if (status === 'denied') {
                        this.$root.$emit('alert', 'Buchung wurde abgelehnt.');
                    }

                    this.load();
                    this.$emit('reload');
                })
                .catch(error => {
                    this.$root.$emit('error', error);
                    this.loading = false;
                });
        },
        getReadableInterval(interval) {
            switch (interval) {
                case "daily":
                    return "Tag(e)"
                case "weekly":
                    return "Woche(n)"
                case "monthly":
                    return "Monat(e)"
                case "yearly":
                    return "Jahr(e)"
            }
        }
    },
}
</script>

<style scoped>

</style>
